import React, { lazy, Suspense } from 'react';
import { Button, Drawer, IconButton } from '@mui/material';
import './index.css';
import * as PropTypes from 'prop-types';
import { setDisconnect } from '../../../actions/account';
import { connect } from 'react-redux';
import variables from '../../../utils/variables';
import Icon from '../../../components/Icon';
import { config } from '../../../config';
import CopyButton from '../../../components/CopyButton';
import { commaSeparator, splitDecimals } from '../../../utils/numbers';
import withRouter from '../../../components/WithRouter';
import flixToken from '../../../assets/tokens/flix.svg';
import { setLibraryTabValue } from '../../../actions/library';
import DepositeDialog from '../../Account/IBCTokens/DepositeDialog';
import WithDrawDialog from '../../Account/IBCTokens/WithDrawDialog';
import CircularProgress from '../../../components/CircularProgress';
import { getWrapAddress } from '../../../utils/strings';
import ImageOnLoad from '../../../components/ImageOnLoad';
import { ReactComponent as CloseIcon } from '../../../assets/interactive/close.svg';
import para from '../../../utils/para';

const IBCTokens = lazy(() => import('./IBCTokens').then().catch());
const RecentCollections = lazy(() => import('./RecentCollections').then().catch());
const RecentNFTs = lazy(() => import('./RecentNFTs').then().catch());
const RecentListed = lazy(() => import('./RecentListed').then().catch());

const SidePanel = (props) => {
    let balance = props.balance && props.balance.length && props.balance.find((val) => val.denom === config.COIN_MINIMAL_DENOM);
    balance = balance && balance.amount && splitDecimals(balance.amount / (10 ** config.COIN_DECIMALS));

    const handleDisconnect = (path) => {
        props.onClose();
        props.router.navigate(path);

        if (path === '/') {
            props.setDisconnect();
            localStorage.removeItem('acToken_of_studio');
            localStorage.removeItem('rfToken_of_studio');
            localStorage.removeItem('address_of_studio');
            localStorage.removeItem('studio_leap');
            localStorage.removeItem('studio_metamask');
            localStorage.removeItem('studio_cosmostation');
            localStorage.removeItem('studio_para');
            if (para) {
                para.logout().then();
            }
        }
    };

    const handleRedirect = (value) => {
        props.router.navigate(value);
        props.onClose();
    };

    const handleRedirectTabs = (value) => {
        props.router.navigate('/library');
        props.setLibraryTabValue(value);
        props.onClose();
    };

    const userUrl = props.profilePicture?.profile_image;
    const userCdnUrl = props.profilePicture?.profile_image_cdn?.variants;

    return (
        <Drawer
            anchor="right"
            className="side_panel"
            open={props.open}
            onClose={props.onClose}>
            <Suspense fallback={<CircularProgress/>}>
                <div className="side_panel_content scroll_bar">
                    <div className="heading">
                        <h2>{props.name || variables[props.lang]['my_account']}</h2>
                        <div className="right_content">
                            <IconButton className="account_image" onClick={() => handleRedirect('/account')}>
                                {userCdnUrl || userUrl
                                    ? <ImageOnLoad
                                        cdn={userCdnUrl}
                                        src={userUrl}/>
                                    : <Icon className="profile" icon="profile"/>}
                            </IconButton>
                            <IconButton className="close_icon" onClick={props.onClose}>
                                <CloseIcon/>
                            </IconButton>
                        </div>
                    </div>
                    <div className="network">
                        <div className="header">
                            <h3>
                                <img alt="icon" height="30" src={flixToken} width="30"/>
                                {variables[props.lang]['omniflix_network']}
                            </h3>
                            <p>Chain : {config.CHAIN_ID}</p>
                        </div>
                        <div className="content">
                            <div className="row">
                                <div className="address">
                                    <p>{variables[props.lang]['connected_with_keplr']}</p>
                                    <div className="copy_div">
                                        <div className="hash_text" title={props.address}>
                                            {getWrapAddress(props.address, 8)}
                                        </div>
                                        <CopyButton data={props.address}/>
                                    </div>
                                </div>
                                <IconButton>
                                    <Icon className="re_direct" icon="re_direct"/>
                                </IconButton>
                            </div>
                            <p className="balance">
                                <img alt="icon" height="30" src={flixToken} width="30"/>
                                {config.COIN_DENOM}&nbsp;
                                <span>
                                    {balance && balance.length
                                        ? <>
                                            {balance.length && balance[0] && commaSeparator(balance[0])}
                                            {balance.length && balance[1] &&
                                                <span>.{balance.length && balance[1]}</span>}
                                        </>
                                        : 0}
                                </span>
                            </p>
                        </div>
                    </div>
                    <div className="recently_collected ibc_tokens">
                        <div className="header">
                            <p className="sub_heading">{variables[props.lang]['ibc_tokens']}</p>
                            <p
                                className="see_all"
                                onClick={() => handleRedirect('/account')}>{variables[props.lang]['see_all']} &#8594;</p>
                        </div>
                        <IBCTokens/>
                    </div>
                    <div className="recently_collected">
                        <div className="header">
                            <p className="sub_heading">{variables[props.lang]['recently_collected']}</p>
                            <p
                                className="see_all"
                                onClick={() => handleRedirectTabs('collections')}>{variables[props.lang]['see_all']} &#8594;</p>
                        </div>
                        <RecentCollections onClose={props.onClose}/>
                    </div>
                    <div className="recently_collected">
                        <div className="header">
                            <p className="sub_heading">{variables[props.lang]['recently_minted']}</p>
                            <p
                                className="see_all"
                                onClick={() => handleRedirectTabs('nfts')}>{variables[props.lang]['see_all']} &#8594;</p>
                        </div>
                        <RecentNFTs onClose={props.onClose}/>
                    </div>
                    <div className="recently_collected">
                        <div className="header">
                            <p className="sub_heading">{variables[props.lang]['recently_listed']}</p>
                            <p
                                className="see_all"
                                onClick={() => handleRedirectTabs('listed')}>{variables[props.lang]['see_all']} &#8594;</p>
                        </div>
                        <RecentListed onClose={props.onClose}/>
                    </div>
                    <div className="footer">
                        <Button
                            aria-label="disconnect" className="disconnect_button"
                            onClick={() => handleDisconnect('/')}>
                            {variables[props.lang].disconnect}
                        </Button>
                    </div>
                </div>
            </Suspense>
            <DepositeDialog/>
            <WithDrawDialog/>
        </Drawer>
    );
};

SidePanel.propTypes = {
    address: PropTypes.string.isRequired,
    balance: PropTypes.array.isRequired,
    balanceList: PropTypes.array.isRequired,
    balanceListInProgress: PropTypes.bool.isRequired,
    connectIBCAccount: PropTypes.func.isRequired,
    faucetClaim: PropTypes.object.isRequired,
    fetchFaucetClaim: PropTypes.func.isRequired,
    fetchIBCBalanceList: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    setDisconnect: PropTypes.func.isRequired,
    setLibraryTabValue: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    profilePicture: PropTypes.array,
    router: PropTypes.shape({
        navigate: PropTypes.func.isRequired,
    }),
};

const stateToProps = (state) => {
    return {
        address: state.account.connection.address,
        balance: state.account.bc.balance.value,
        lang: state.language,

        profilePicture: state.account.profilePicture.getProfilePicture.value,
    };
};

const actionToProps = {
    setDisconnect,
    setLibraryTabValue,
};

export default withRouter(connect(stateToProps, actionToProps)(SidePanel));
